import { render, staticRenderFns } from "./XmlOrders.vue?vue&type=template&id=5e816f52&scoped=true"
import script from "./XmlOrders.vue?vue&type=script&lang=ts"
export * from "./XmlOrders.vue?vue&type=script&lang=ts"
import style0 from "./XmlOrders.vue?vue&type=style&index=0&id=5e816f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e816f52",
  null
  
)

export default component.exports